import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, Form } from 'react-bootstrap';
import logo from '../../assets/img/Humano.png';
import huLogo from '../../assets/img/Hu-white.png';
import UserDropdown from '../UserDropdown';
import { isBrowser, isMobile } from "react-device-detect";
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';

const navLinkStyle = {
    color: 'white',
    textDecoration: 'none'
}

const activeLinkStyle = {
    fontWeight: 'bold'
}


const HuStyle = {
    marginTop: 10,
}

const marginLeft = {
    marginLeft: 250
}

const bardsStyle = {
    color: 'white'
}

const browserBarsStyle = {
    ...marginLeft, 
    ...bardsStyle
}

const successNotify = (text = "Operación realizada con éxito") => toast.success(text, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

const Header = ({ toggleSidebar, opeationSuccess }) => {
    useEffect(() => {
        if (opeationSuccess != 0) {
            successNotify();
        }
    }, [opeationSuccess])

    return (
        <>
            <ToastContainer />
            <Navbar bg="primary" variant="dark" style={{height: 75}}>
                <Nav className="mr-auto">
                    {
                        isBrowser &&
                        <div style={HuStyle}>
                            {/* <img src={huLogo} style={{width: 50}} alt="logo" /> */}
                        </div>
                    }

                    {
                        isBrowser &&
                        <Nav.Link style={browserBarsStyle} onClick={toggleSidebar}>
                            <i className="fa fa-bars"></i>
                        </Nav.Link>
                    }
                    
                </Nav>
                <Form inline>
                    <Nav.Link as={NavLink} to="/" style={navLinkStyle} exact activeStyle={activeLinkStyle}>
                        <img src={logo} alt="logo" />
                    </Nav.Link>
                    {
                        isMobile &&
                        <Nav.Link style={bardsStyle} onClick={toggleSidebar}>
                            <i className="fa fa-bars"></i>
                        </Nav.Link>
                    }
                    <UserDropdown />
                </Form>
            </Navbar>
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        opeationSuccess: state.opeationSuccess,
    }
}

export default connect(mapStateToProps)(Header);